module.exports = __webpack_public_path__ + "img/type2-2.6a6a4429.png";